export type BrandColorMode = {
  light: string;
  dark: string;
};

export type Brand = {
  productName: string;
  logoUrl: string;
  logoMarkUrl?: string;
  faviconUrl: string;
  primary: BrandColorMode;
  accent: BrandColorMode;
  supportEmail: string;
  supportUrl: string | null;
  marketingTagline: string;
  legalName?: string;
};

export const brand: Brand = {
  productName: 'VoxVec',
  logoUrl: '/brand/logo.svg',
  logoMarkUrl: '/brand/mark.svg',
  faviconUrl: '/brand/mark.svg',
  primary: { light: '240 5.9% 10%', dark: '0 0% 98%' },
  accent: { light: '240 4.8% 95.9%', dark: '240 3.7% 15.9%' },
  supportEmail: 'hello@voxvec.com',
  supportUrl: null,
  marketingTagline: 'Keep in touch with your customers',
  legalName: 'Voice Agent',
};

export function brandTitle(title?: string): string {
  const base = `${brand.productName} Studio`;
  return title ? `${title} | ${base}` : base;
}

export function brandCssVariables(value: Pick<Brand, 'primary' | 'accent'> = brand): string {
  return `:root { --primary: ${value.primary.light}; --accent: ${value.accent.light}; }
.dark { --primary: ${value.primary.dark}; --accent: ${value.accent.dark}; }`;
}
